
//#region category
export function CategoryConfigModel(strConfig, strSponsorId, strTags, strLocale) {
    this.strConfig = strConfig || "";
    this.strSponsorId = strSponsorId || "";
    this.strTags = strTags || "";
    this.strLocale = strLocale;  
}

export function CategoryConfigBuilder() {
    this.categoryConfig = new CategoryConfigModel();

    this.create = () => {
        return this.categoryConfig;
    };

    this.setConfig = (strConfig) => {
        this.categoryConfig.strConfig = strConfig;
        return this;
    };

    this.setSponsorId = (strSponsorId) => {
        this.categoryConfig.strSponsorId = strSponsorId;
        return this;
    };

    this.setTags = (strTags) => {
        this.categoryConfig.strTags = strTags;
        return this;
    };

    this.setLocale = (strLocale) => {
        this.categoryConfig.strLocale = strLocale;
        return this;
    };
}
//#endregion category